import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mainFormContainer: {
    margin: theme.spacing(10, 0),
    padding: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 16),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 10, 0, 17),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 12),
    },
  },
  financialYearContainer: {
    marginBottom: theme.spacing(15),
  },
  financialReportLinksContainer: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(15),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
  },
  financialReportLink: {
    minWidth: '322px',
    [theme.breakpoints.up('sm')]: {
      minWidth: '352px',
    },
    backgroundColor: theme.palette.background.grey,
    padding: theme.spacing(2),
    '& svg': {
      fill: theme.palette.secondary.main,
    },
    '& > a': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  financialReportName: {
    display: 'flex',
    '& > h6': {
      marginLeft: theme.spacing(2),
      color: theme.palette.secondary.main,
    },
  },
}))
